"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  container: {
    width: '100%',
    height: '100%',
    WebkitBackdropFilter: 'blur(4px)',
    backdropFilter: 'blur(4px)',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    position: 'fixed',
    left: 0,
    top: 0,
    transition: 'background .5s',
    zIndex: 500
  },
  containerOpen: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)'
  },
  overlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%'
  },
  panel: {
    fontSize: '1.4rem',
    position: 'fixed',
    height: '100%',
    zIndex: '1000',
    backgroundColor: 'white',
    top: 0,
    left: '100%',
    transition: 'all .5s',
    overflow: 'scroll'
  },
  panelOpen: {
    transform: 'translateX(-100%)'
  },
  content: {
    margin: 30,
    minHeight: 'calc(100% - 74px)'
  }
};

function SidePanel(props) {
  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var close = function close() {
    if (props.canNotClose) {
      return;
    }

    setIsOpen(false);
    setTimeout(props.onClose, 500);
  };

  if (props.setCloseTrigger) {
    props.setCloseTrigger(close);
  }

  _react.default.useEffect(function () {
    return setIsOpen(true);
  }, []);

  var containerStyle = _objectSpread(_objectSpread({}, styles.container), isOpen ? styles.containerOpen : {});

  var panelStyle = _objectSpread(_objectSpread({}, styles.panel), isOpen ? styles.panelOpen : {});

  var classNameOverlay = props.big ? 'col-xl-5 col-lg-2' : 'col-xl-6 col-lg-5 col-md-2';
  var classNamePanel = props.big ? 'col-xl-7 col-lg-10' : 'col-xl-6 col-lg-7 col-md-10';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: containerStyle,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: styles.overlay,
      onClick: close,
      className: classNameOverlay
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: panelStyle,
      className: classNamePanel,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: styles.content,
        children: props.children
      })
    })]
  });
}

SidePanel.defaultProps = {
  children: null,
  big: false,
  canNotClose: false
};
SidePanel.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  onClose: _propTypes.default.func,
  big: _propTypes.default.bool,
  canNotClose: _propTypes.default.bool,
  setCloseTrigger: _propTypes.default.func
};
var _default = SidePanel;
exports.default = _default;
//# sourceMappingURL=SidePanel.js.map